module.exports = __webpack_public_path__ + "img/section4LeftModel.32324d72.webp";